import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import PrivateRoute from '../modules/profile/components/PrivateRoute';
import { Role } from '../models';
import RouteKey from './key';
import StatementOfResults from '../pages/statementOfResults/StatementOfResults';

const { error: errorRoute } = RouteKey.child;

const { root: statementOfResults } = RouteKey['statement-of-results'].child;

const StatementOfResultsRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <PrivateRoute exact path={`${path}`} roles={[Role.candidate, Role.coordinator]}>
        <Redirect to={`${path}/${statementOfResults.route}`} />
      </PrivateRoute>
      <PrivateRoute
        path={`${path}/${statementOfResults.route}`}
        roles={[Role.candidate, Role.coordinator]}
      >
        <StatementOfResults />
      </PrivateRoute>
      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};

export default StatementOfResultsRoute;
